import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";

class CommunicationHistorySharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("MessageLabel");
    }

    public getItemIconClass(): string {
        return "";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return false;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(): null {
        return null;
    }

    public getPinFrequencyToken(): string {
        return "";
    }

    public getPinFrequencyDocumentType(): null {
        return null;
    }
}

export { CommunicationHistorySharedItemProvider };
